//if(NODE_ENV == 'development') console.log(NODE_ENV)

window.$ = require("jquery/dist/jquery.min.js");
import "material-design-lite/material.min.js";
//import 'vuetify/src/stylus/components/_dialogs.styl';


import Vue from 'vue'

import vSelect from 'vue-select'
//var VueValidator = require('vue-validator')

import store from './store'
import router from './router'

import App from './App.vue'

//import VueDialog from 'vue-dialog'
//Vue.use(VueDialog)

import VuejsDialog from "vuejs-dialog"
Vue.use(VuejsDialog)

import Lightbox from "vue-easy-lightbox"
Vue.use(Lightbox)

//import Vuetify from 'vuetify'
//Vue.use(Vuetify)

//console.log(Vue.prototype)

//import VuetifyDialog from 'vuetify-dialog'
//Vue.use(VuetifyDialog)

Vue.component('v-select', vSelect)
import ui from './mixins/ui.js'
import lightbox from './mixins/lightbox.js'

import user from './mixins/user.js'

window.vm = new Vue({
  el: '#app',
  store,
  router,
  mixins: [ui, user, lightbox],
  render: h => h(App),
  modal: {}
})

if (module.hot) {
  const hotEmitter = require("webpack/hot/emitter");
  const DEAD_CSS_TIMEOUT = 2000;

  hotEmitter.on("webpackHotUpdate", function(currentHash) {
    document.querySelectorAll(".webpack-stylesheet").forEach((link) => {
      const nextStyleHref = link.href.replace(/(\?\d+)?$/, `?${Date.now()}`);
      const newLink = link.cloneNode();
      newLink.href = nextStyleHref;

      link.parentNode.appendChild(newLink);
      setTimeout(() => {
        link.parentNode.removeChild(link);
      }, DEAD_CSS_TIMEOUT);
    });
  })
}


// WEBPACK FOOTER //
// ./reports/assets/src/main.js